import { configureStore, combineReducers } from '@reduxjs/toolkit';
import coreReducer from './coreSlice';
import modalReducer from './modalSlice';
import listReducer from './listSlice';
import elementReducer from './elementSlice';
import sidebarReducer from './sidebarSlice';
import actionsReducer from './actionsSlice';
import automationReducer from './automationSlice';
import auraReducer from './auraSlice';
import pulseReducer from './pulseSlice';
import maestroReducer from './maestroSlice';
import realtimeReducer from './realtimeSlice';
import notificationsReducer from './notificationsSlice';
import presenceReducer from './presenceSlice';
import onboardingReducer from './onboardingSlice';
import customizationsReducer from './customizationsSlice';
import brandReducer from './brandSlice';
import atelierReducer from './atelierSlice';
import addonsReducer from './addonsSlice';
import maestroAddonsReducer from './maestroAddonsSlice';
import toursReducer from './toursSlice';
import timesheetTimerReducer from './timesheetTimerSlice';
import coreSeqJobsReducer from './coreSeqJobsSlice';

export const RESET_STORE = 'RESET_STORE';

export const resetAllStores = () => ({ type: RESET_STORE });

const appReducer = combineReducers({
  core: coreReducer,
  modals: modalReducer,
  list: listReducer,
  element: elementReducer,
  sidebar: sidebarReducer,
  actions: actionsReducer,
  automation: automationReducer,
  aura: auraReducer,
  pulse: pulseReducer,
  maestro: maestroReducer,
  realtime: realtimeReducer,
  notifications: notificationsReducer,
  presence: presenceReducer,
  onboarding: onboardingReducer,
  customizations: customizationsReducer,
  brand: brandReducer,
  atelier: atelierReducer,
  addons: addonsReducer,
  maestroAddons: maestroAddonsReducer,
  tours: toursReducer,
  timesheetTimer: timesheetTimerReducer,
  coreSeqJobs: coreSeqJobsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['modals/openModal', 'modals/saveCreateElementDraft'],
        ignoredPaths: [
          'modals.modalProps.handleDone',
          'modals.modalProps.onConfirm',
          'modals.modalProps.onDeleteSuccess',
          'modals.createElementDrafts',
        ],
      },
    }),
});
